import { NODE_WIDTH, NODE_HEIGHT } from './constants';

/**
 * Build a position map from nodePositions and customPositionsRef
 */
export function buildPositionMap(nodePositions, customPositionsRef) {
  const currentCustomPositions = customPositionsRef?.current || {};
  const positionMap = { ...nodePositions };
  Object.entries(currentCustomPositions).forEach(([id, pos]) => {
    positionMap[id] = pos;
  });
  return positionMap;
}

/**
 * Get all positions for overlap checking
 */
export function getAllPositions(tasks, positionMap, nodeDimensions) {
  const currentCustomPositions = positionMap;
  const taskIds = new Set(tasks.map(t => t.id));
  const allIds = new Set([...taskIds, ...Object.keys(currentCustomPositions)]);
  
  return Array.from(allIds).map(id => {
    const pos = positionMap[id];
    const dims = nodeDimensions[id] || { width: NODE_WIDTH, height: NODE_HEIGHT };
    return pos ? { ...pos, width: dims.width, height: dims.height, id } : null;
  }).filter(Boolean);
}

/**
 * Create an overlap checker function for a given set of positions
 */
export function createOverlapChecker(allPositions, padding = 30) {
  return (x, y, width = NODE_WIDTH, height = NODE_HEIGHT) => {
    for (const node of allPositions) {
      const overlapX = x < node.x + node.width + padding && x + width + padding > node.x;
      const overlapY = y < node.y + node.height + padding && y + height + padding > node.y;
      if (overlapX && overlapY) return true;
    }
    return false;
  };
}

/**
 * Standard spiral directions for searching empty space
 */
export const SPIRAL_DIRECTIONS = [
  { dx: 0, dy: -1 },   // N
  { dx: 1, dy: -1 },   // NE
  { dx: 1, dy: 0 },    // E
  { dx: 1, dy: 1 },    // SE
  { dx: 0, dy: 1 },    // S
  { dx: -1, dy: 1 },   // SW
  { dx: -1, dy: 0 },   // W
  { dx: -1, dy: -1 },  // NW
];

/**
 * Downward-biased directions (for placing below source nodes)
 */
export const DOWNWARD_DIRECTIONS = [
  { dx: 0, dy: 1 },    // S (below) - most preferred
  { dx: 1, dy: 1 },    // SE
  { dx: -1, dy: 1 },   // SW
  { dx: 1, dy: 0 },    // E (right)
  { dx: -1, dy: 0 },   // W (left)
  { dx: 0, dy: -1 },   // N (above) - least preferred
  { dx: 1, dy: -1 },   // NE
  { dx: -1, dy: -1 },  // NW
];
